import { configureStore } from "@reduxjs/toolkit";
import popupSlice from "./popup-slice";
import loginSlice from "./userLogin-slice";
import cartSlice from "./cart-slice";
import searchSlice from "./Search-slice";

const store = configureStore({
  reducer: {
    popup: popupSlice.reducer,
    loginUser: loginSlice.reducer,
    cart: cartSlice.reducer,
    search: searchSlice.reducer,
  },
});

export default store;
